import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from '../../../components/Seo';

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { HeaderLogoAndTel } from '../../../components/HeaderLogoAndTel';
import { FooterFull } from '../../../components/FooterFull';
import { GetCourseWidget } from '../../../components/GetCourseWidget';
import { TaxDeduction } from '../../../components/TaxDeduction';

import * as main from './styles/main.module.scss';
import * as screen1 from './styles/screen1.module.scss';
import * as target from './styles/target.module.scss';
import * as tasks from './styles/tasks.module.scss';
import * as consist from './styles/consist.module.scss';
import * as cost from './styles/cost.module.scss';
import * as adv from './styles/advance.module.scss';
import { PartnersTrust } from '../../../components/PartnersTrust';
const Screen1 = () => {
  return (
    <section className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel />
        <div className={screen1.container}>
          <div className={screen1.info}>
            <p className={screen1.type}>Закрытый мастер-класс для родителей</p>
            <h1>Как школьнику делать домашнее задание легко и самостоятельно?</h1>
            <p className={screen1.desc}>
              Мы расскажем, как без ссор и переживаний повысить успеваемость по любым предметам.
            </p>
            <a href="#widget" className={main.btn}>
              Зарегистрироваться
            </a>
            <div className={screen1.bonus}>
              <h3>Бонус при покупке:</h3>
              <p>видео «Что мешает ребёнку учиться в школе?»</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
const Target = () => {
  return (
    <section className={target.target}>
      <div className={`container ${target.container}`}>
        <img
          src="https://fs.advance.ru/landing-pages/webinar/kak_delat_domashnee_zadanie_legko/_v2/photo-fear.png"
          alt=""
        />
        <div className={target.info}>
          <h2 className={main.title}>Для кого мастер-класс будет полезен:</h2>
          <ul>
            <li>ваш ребёнок тратит на ДЗ больше часа в день;</li>
            <li>ваш ребёнок садится за уроки только вместе с вами;</li>
            <li>ребёнок приступает к выполнению домашнего задания поздно вечером;</li>
            <li>ваш ребёнок устает от уроков и не может сконцентрироваться на заданиях;</li>
            <li>ваш ребенок не хочет учиться.</li>
          </ul>
          <a href="#widget" className={main.btn}>
            Помочь ребенку с обучением
          </a>
        </div>
      </div>
    </section>
  );
};
const Tasks = () => {
  return (
    <section className={tasks.tasks}>
      <div className="container">
        <div className={tasks.container}>
          <h2 className={main.title}>Какие задачи решает мастер-класс:</h2>
          <ul>
            <li>
              Помогаем родителям <strong>проанализировать свой стиль общения</strong> с ребёнком и стиль воспитания.
            </li>
            <li>
              Рассказываем, <strong>какие обстоятельства</strong> влияют на хорошую учёбу.
            </li>
            <li>
              Рассказываем о том, <strong>как правильно делать домашнее задание</strong>. Вырабатываем пошаговую
              инструкцию
            </li>
            <li>
              <strong>Помогаем понять</strong>, насколько ребёнок мотивирован на учёбу.
            </li>
            <li>
              Знакомим с <strong>основными технологиями</strong>, используемыми в Advance.
            </li>
            <li>
              Обучаем упражнениям <strong>на переключение внимания.</strong>
            </li>
            <li>
              Рассказываем <strong>о привычках и навыках</strong>, которые полезны при выполнении домашнего задания.
            </li>
            <li>
              <strong>Анализируем причины</strong>, по которым у ребёнка не получается успешно делать домашнее задание.
            </li>
            <li>
              Рассказываем про <strong>договор, как инструмент мотивирования ребёнка.</strong>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
const Consist = () => {
  return (
    <section className={consist.consist}>
      <div className="container">
        <div className={consist.container}>
          <div className={consist.info}>
            <h2 className={main.title}>Курс состоит из 9 уроков,</h2>
            <p>
              включающих в себя видеолекции, тесты, упражнения, а также полезные материалы для практической отработки
              технологий Advance.
            </p>
          </div>
          <img
            src="https://fs.advance.ru/landing-pages/webinar/kak_delat_domashnee_zadanie_legko/_v2/photo-lesson.png"
            alt=""
          />
        </div>
      </div>
    </section>
  );
};
const Cost = ({ widget }) => {
  return (
    <section className={cost.cost}>
      <div className="container">
        <div className={cost.container}>
          <div className={cost.info}>
            <h2>
              Стоимость
              <br /> мастер-класса
            </h2>
            <div className={cost.priceWrap}>
              <p className={cost.priceOld}>5 000 ₽</p>
              <p className={cost.priceNew}>3 490 ₽</p>
            </div>
            <TaxDeduction className={cost.tax} />
          </div>
          <div className={cost.form} id={'widget'}>
            {widget}
          </div>
        </div>
      </div>
    </section>
  );
};
const Advance = () => {
  return (
    <section className={adv.adv}>
      <div className="container">
        <div className={adv.container}>
          <img
            src="https://fs.advance.ru/landing-pages/webinar/kak_delat_domashnee_zadanie_legko/_v2/adv-logo.svg"
            alt=""
          />
          <h2>Мы — центр образовательных технологий Advance</h2>
          <ul>
            <li>
              <h3>С 2009 года</h3>
              <p>учим людей раскрывать и развивать свой интеллектуальный потенциал, повышать личную эффективность</p>
            </li>
            <li>
              <h3>1 700 000</h3>
              <p>
                человек
                <br /> приняли участие
                <br /> в наших курсах и семинарах
              </p>
            </li>
            <li>
              <h3>85 000</h3>
              <p>
                человек
                <br /> прошли наши полные курсы
              </p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

const TITLE =
  'Как школьнику делать домашнее задание легко и самостоятельно? | Центр образовательных технологий Advance';
const DESCRIPTION =
  'Мы расскажем, как без ссор и переживаний повысить успеваемость по любым предметам | Центр образовательных технологий Advance ✅Уникальные методики обучения ✅ Эффективное запоминание материала ✅100% результат ☝️ Заходите!';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget = <GetCourseWidget hash={'6b1a85d0e980551e074ffde1773f0656cb2b6806'} id={'1193056'} /> }) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{ color: '#343A40' }}>
      <Screen1 />
      <Target />
      <Tasks />
      <Consist />
      <Cost widget={widget} />
      <Advance />
      <PartnersTrust ttlName={adv.partnersTtl} />
    </main>

    <FooterFull />
  </DefaultLayout>
);
export default Page;
